/* eslint-disable */

import request from '@/utils/request'

export function getListBankAccountApi(query) {
  return request({
    url: '/config-service/v1/bank-account/list',
    method: 'get',
    params: query
  })
}
export function getListPMSBankAccountApi(query) {
  return request({
    url: '/config-service/v1/bank-account/list/pms',
    method: 'get',
    params: query
  })
}

export function addBankAccountApi(query) {
  return request({
    url: '/config-service/v1/bank-account',
    method: 'post',
    data: query
  })
}

export function updateBankAccountApi(query) {
  return request({
    url: '/config-service/v1/bank-account',
    method: 'put',
    data: query
  })
}

export function deleteBankAccountApi(query) {
  return request({
    url: '/config-service/v1/bank-account',
    method: 'delete',
    data: query
  })
}

export function getTicketOfficeOptionsApi() {
  return request({
    url: '/config-ticket-service/v1/ticket-office',
    method: 'get'
  })
}
